import { ExternalLink } from 'lucide-react'
import { useLocalPrintAgent, isLocalPrintAgentOnline } from '@/hooks/useLocalPrintAgent'
import { printApi } from '@/lib/api/print'

export function ScanAgentBadge() {
  const { data: local, isLoading } = useLocalPrintAgent()
  const online = isLocalPrintAgentOnline(local)

  return (
    <div className="flex items-center gap-2 text-sm">
      <span
        className={`inline-block w-2 h-2 rounded-full ${online ? 'bg-green-500' : 'bg-gray-300'}`}
        title={online ? 'локальный агент online' : 'локальный агент offline'}
      />
      <span className={online ? 'text-green-700' : 'text-gray-500'}>
        {isLoading
          ? 'Агент…'
          : online
            ? `COM ${local?.scan_port || '—'}${local?.has_token ? '' : ' · нет токена'}`
            : 'Локальный агент offline'}
      </span>
      <a
        href={printApi.localAgentSettingsUrl()}
        target="_blank"
        rel="noreferrer"
        className="text-blue-600 hover:underline inline-flex items-center gap-0.5"
      >
        Настройки
        <ExternalLink className="w-3 h-3" />
      </a>
    </div>
  )
}
